import executeRequests from './lib/execute-requests.js'
import handleResponses from './lib/handle-responses.js'
import setContextOriginal from './set-context-original.js'

// When you save, you have the option of updating and mutating the
// context object, typically checking values off the `form.$` object.
// Then, when the requests are resolved, you need to re-apply the
// original pre-form mutator if the page uses one.
export default ({ component, page, preSaveMutator, preFormMutator }) => ({ detail: { context } }) => {

    if (preSaveMutator) {
        // Example use would be where '$.isChecked' toggles some string:
        //
        //   if (!context.form.$.isCustomLocation) {
        //       context.form.game.attributes.customLocation = removeProperty
        //   }
        //
        preSaveMutator({ context, component })
    }
    component.$set({ saving: true })
    return executeRequests({ component, page, context })
        .then(responses => {
            const { alerts, errors, updatedForm } = handleResponses({ page, responses, context })

            // need to attempt to preserve changes for keys that have errors/alerts
            const alertsByFormKey = alerts.reduce((map, alert) => {
                map[alert.formKey] = map[alert.formKey] || {}
                map[alert.formKey][alert.index] = map[alert.formKey][alert.index] || alert.error
                return map
            }, {})

            let preservedChanges = {}
            Object.keys(context.changes).forEach(formKey => {

                preservedChanges[formKey] = preservedChanges[formKey] || {}

                Object.keys(context.changes[formKey]).forEach(index => {
                    if (alertsByFormKey[formKey] && alertsByFormKey[formKey][index]) {
                        preservedChanges[formKey][index] = preservedChanges[formKey][index] || context.changes[formKey][index]
                    }
                })
            })

            const newContext = setContextOriginal(
                {
                    context: {
                        errors: errors && errors.length ? errors : undefined,
                        alerts: alerts && alerts.length ? alerts : undefined,
                        form: (alerts && alerts.length) || (errors && errors.length) ? context.form : updatedForm,
                        view: context.view,
                        changes: preservedChanges ? preservedChanges : {}
                    }
                },
                preFormMutator
            )


            component.$set(newContext)
            component.$set({ saving: false })

            if (alerts && alerts.length > 0) {
                return Promise.reject(alerts)
            }

            return responses
        })
}
